export default {"src":"/_next/static/media/Afterpay-Logo.91a8b08d.svg","height":221,"width":1149,"blurWidth":0,"blurHeight":0};